import React, { useRef, useState } from "react";
import { Button, Checkbox } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import TopTitleFormComponent from "./TopTitleFormComponent";
import { getDoc, doc } from "firebase/firestore";
import { useEffect } from "react";
import { db } from "../../firebase";
import ReactToPrint from "react-to-print";
import "./AdmissionDocumentRedesign.css";

function ViewAgressionControlPolicy(props) {
  const [signaturePic, setSignaturePic] = useState(null);
  const [text0, setText0] = useState("");
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text2bis, setText2bis] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");
  const [text5, setText5] = useState("");
  const [text6, setText6] = useState("");
  const printRef = useRef();

  function formatDate(timestamp) {
    const date = timestamp.toDate();
    const day = date.getDate().toString().padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const timeZone = date
      .toLocaleString("en", { timeZoneName: "short" })
      .split(" ")
      .pop();

    return `${day} ${month} ${year} ${hours}:${minutes} ${timeZone}`;
  }

  const fetchSignatureUrl = async () => {
    const docRef = doc(db, "AgressionControlPolicy", props.clientId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      const signatureUrl = data.signatureURL;
      setSignaturePic(signatureUrl);
      setText0(data.text0);
      setText1(data.text1);
      setText2(data.text2);
      setText2bis(data.text2bis);
      setText3(data.text3);
      setText4(data.text4);
      setText5(data.text5);
      setText6(data.text6);
    } else {
    }
  };

  useEffect(() => {
    fetchSignatureUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <style>
        {`
          @media print {
            #printableContent {
              height: auto !important;
              overflow-y: visible !important;
            }
          }
        `}
      </style>

      <div className="admission-document-shell admission-card-form-shell aggression-form-shell"
        // className="inputAndLabelModalContainerTitle2"
        style={{ width: "auto", height: "100%" }}
      >
        <TopTitleFormComponent
          title="Aggression control policy form"
          eyebrow="Admission form"
          subtitle={`${props.firstName || "Client"} ${props.lastName || ""}`.trim()}
          closemodal={props.closemodal}
        />

        <div
          id="printableContent"
          style={{
            width: "100%",
            marginTop: "10px",
            height: "75%",
            overflowY: "scroll",
            // overflowX: "hidden",
          }}
          ref={printRef}
          // style={{ marginTop: "60px", height: "500px", overflowY: "scroll" }}
          // style={{ marginTop: "60px", height: "auto", overflowY: "scroll" }}
        >
          <div className="client-name-container">
            Agression control policy form for: {props.firstName}{" "}
            {props.lastName}
          </div>
          <br />

          <div className="SubTitleBold">{text0}</div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text1}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text2}</div>
          </div>

          <div className="SubTitleBold">{text2bis}</div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text3}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text4}</div>
          </div>

          <div className="SubTitleBold">Incident reports:</div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text5}</div>
          </div>

          <div className="SubTitleBold">Acknowledgement</div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text6}</div>
          </div>

          <div className="signature-date-container">
            <div className="text-block-2">
              Timestamp signature :{" "}
              {formatDate(props.AggressionControlPolicyDateSigned)}{" "}
            </div>
            <div className="signature-title">
              Client signature (
              <span style={{ fontWeight: "bold" }}>
                {props.firstName} {props.lastName}
              </span>
              ):
            </div>
            <img
              alt="Signature"
              className="signature-pic-roi"
              src={signaturePic}
            />
          </div>
        </div>
        <div className="line4-modal">
          <>
            <Button
              variant="contained"
              style={{ backgroundColor: "white", color: "black" }}
              onClick={props.closemodal}
            >
              Cancel
            </Button>

            <ReactToPrint
              trigger={() => (
                <Button variant="contained" style={{ marginLeft: "20px" }}>
                  Print
                </Button>
              )}
              content={() => printRef.current}
              onAfterPrint={props.closemodal}
            />
          </>
        </div>
      </div>
    </>
  );
}

export default ViewAgressionControlPolicy;
